define('source/sourcecompleter',['jquery', 'utils/cache', 'source/source'], function ($, Cache, Source) {

	/**
	 * Source
	 * 
	 *  options: 
	 *  onAdd: callback when an item has been added
	 *  onRemove: callback when an item has been removed
	 *  
	 *  formatter: function (item, term) {} how the element should be formatted
	 *  cache : boolean whether or not to cache
	 *  
	 *  value: Value string object name
	 *  
	 *  url: where to fetch the data
	 */
	var SourceCompleter = function (options) {
		this.options = $.extend({
			onAdd : function(data) {
                if ($.isNumeric(data.id)) {
                    $(this.options.selector).after($('<input type="hidden" name="'+this.options.name+'[]" value="'+data.id+'">'));
                }
			},
			
			onRemove : function (id) {
				$(this.options.selector).parent().find('input[value='+id+']').remove();
			},
			
			formatter : function (item, term) {
				var str = item.name.htmlspecialchars();
				term = term.htmlspecialchars();
				
				var pos = str.toLowerCase().indexOf(term.toLowerCase());
				var org = str.substr(pos, term.length); // keep uppercase and lowercase
				
				var name = item.name.replace(new RegExp(term, 'i'), '<span class="marked">'+org+'</span>');

				var userIcon = (item.user_id !== undefined)?'<span class="icon-user"></span>':'';
				var ret = $('<li><a href="#">' + name + userIcon + '</a></li>');

				if(item.user_id !== undefined)
					ret.addClass("type_user_tag");
				
				return ret;
			},
			cache : true,
			name : '', // Atribuut naam om geselcteerde items in op te slaan
			value : 'name',
			id : '',
			url : '',
			selector : null
		}, options);
		
		if(this.options.selector == null) {
			this.options.selector = '#' + this.options.id;
		}
		
		this.cache = new Cache({
			enable : this.options.cache,
			source : new Source({
				url : this.options.url
			})
		});
		
		this.isPending = false;
		
		this.getFormatter = function () { return this.options.formatter; };
		
		this.onAdd = function (data) { this.options.onAdd.call(this, data); };	
		this.onRemove = function (data) { this.options.onRemove.call(this, data); };

		this.getLabel = function (data) {
			return data[this.options.value] == undefined ? '' : data[this.options.value];
		};
	};

	/**
	 * retrieve data from cache or url
	 * @param callback function (result) {} 
	 * @param data
	 * TODO Data param verwerken
	 */
	SourceCompleter.prototype.retrieve = function (callback, data) {
		this.cache.load('ALL', callback);
	};

	SourceCompleter.prototype.getItem = function (callback_check) {
		var $this = this;
		return this.cache.getItem('ALL', function (item) {
			return callback_check.call($this, item);
		});
	};
	
	return SourceCompleter;
});
